/**
 * @file DeleteBrochure.js is responsible for rendering the delete brochure modal
 */
import React, { useState } from "react";

import { 
	Button, 
	Modal, 
	ModalOverlay, 
	ModalContent, 
	ModalHeader, 
	ModalFooter, 
	ModalBody, 
	ModalCloseButton,
	Text,
	Input,
	Alert,
	AlertIcon,
	AlertDescription,
	useToast
} from "@chakra-ui/react";

import useDeleteBrochure from "hooks/Brochure/mutations/useDeleteBrochure"; // Update the path as per your project structure

/**
 * @function DeleteBrochure
 * @summary - Modal to delete a brochure
 */
const DeleteBrochure = ({ isOpen, onClose, brochure, refetch }) => {

	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);

	const [confirmText, setConfirmText] = useState("");

	const { deleteBrochure } = useDeleteBrochure();
	const toast = useToast();

	/**
	 * @function handleDeleteBrochure
	 * 
	 * @description - This function is used to delete a gallery image from the database.
	 * 
	 */
	const handleDeleteBrochure = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		setLoading(true);

		let response = await deleteBrochure(brochure._id);
		if(response.error) {
			setErrorMsg(response.error.message);
			setLoading(false);
			return;
		}
		if(response.data) {
			toast({
				title: "Brochure deleted.",
				description: "The brochure has been deleted.",
				status: "success",
				duration: 5000,
				isClosable: true,
			});
			refetch();
			onClose();
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Delete Brochure</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text>Are you sure you want to delete this brochure?</Text>
					<Text fontWeight="bold" mt={2}>This action cannot be undone.</Text>
					{errorMsg && (
						<Alert status="error">
							<AlertIcon />
							<AlertDescription>{errorMsg}</AlertDescription>
						</Alert>
					)}
					<Text mt={4}>Please type <Text as="span" fontWeight="bold">DELETE</Text> to confirm.</Text>
					<Input
						mt={2}
						placeholder="DELETE"
						value={confirmText}
						onChange={(e) => setConfirmText(e.target.value)}
					/>
				</ModalBody>
				<ModalFooter>
					<Button
						variant="primary"
						mr={3}
						onClick={handleDeleteBrochure}
						isLoading={loading}
						isDisabled={confirmText !== "DELETE"}
					>
						Delete
					</Button>
					<Button variant="ghost" onClick={onClose}>
						Cancel
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteBrochure;
